export const CalculateShiftForLastPageInGrid = (currentshift) => {
    currentshift = currentshift.toString();
    var indexofDecimal = currentshift.indexOf('.');
    if (indexofDecimal >= 0) {

        currentshift = currentshift.substring(0, indexofDecimal);
    }

    return parseInt(currentshift,10);
};